export class LaborSetupItem {
	pk: string; //:venueKey
	sk: string; //LABOR_SETUP
	defaultScheduleStartDay: number = 1;

	weeklyOvertime: boolean = true;
	weeklyOvertimeHours: number = 40;
	weeklyOvertimeRate: number = 1.5;

	dailyOvertime: boolean = false;
	dailyOvertimeHours: number = 8;
	dailyOvertimeRate: number = 1.5;

	dailyDoubleOvertime: boolean = false;
	dailyDoubleOvertimeHours: number = 12;
	dailyDoubleOvertimeRate: number = 2.0;

	sixthDayOvertime: boolean = false;
	sixthDayOvertimeRate: number = 0;

	seventhDayOvertime: boolean = false;
	seventhDayOvertimeRate: number = 0;

	jobSpecificRules: LaborSetupJobRule[] = [];

	default: boolean = false;

	public constructor(init?: Partial<LaborSetupItem>) {
		Object.assign(this, init);
	}
}

export class LaborSetupJobRule {
	jobId: number;

	weeklyOvertime: boolean = true;
	weeklyOvertimeHours: number = 40;
	weeklyOvertimeRate: number = 1.5;

	dailyOvertime: boolean = false;
	dailyOvertimeHours: number = 8;
	dailyOvertimeRate: number = 1.5;

	dailyDoubleOvertime: boolean = false;
	dailyDoubleOvertimeHours: number = 12;
	dailyDoubleOvertimeRate: number = 2.0;

	sixthDayOvertime: boolean = false;
	sixthDayOvertimeRate: number = 0;

	seventhDayOvertime: boolean = false;
	seventhDayOvertimeRate: number = 0;

	notes: string;

	jobName: string;

	newJobRule: boolean = false;

	public constructor(init?: Partial<LaborSetupJobRule>) {
		Object.assign(this, init);
	}
}
